<template>
  <v-dialog
    v-model="computedSignshopSignageVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <v-btn icon @click="methodToggleListView('signshop', 'signage')">
          <v-icon>close</v-icon>
        </v-btn>

        <v-toolbar-title class="hidden-sm-and-down"
          >Mountain Signage</v-toolbar-title
        >
        <v-spacer class="hidden-sm-and-down"></v-spacer>
        <v-select
          style="height: 60px;"
          :items="select_mountain_items"
          v-model="select_mountain_model"
          attach
        ></v-select>
        <v-spacer class="hidden-sm-and-down"></v-spacer>
        <v-text-field
          style="height: 60px;"
          append-icon="search"
          single-line
          hide-details
          v-model="search"
          placeholder="Filter data"
        ></v-text-field>
        <v-spacer class="hidden-sm-and-down"></v-spacer>
        <v-btn
          v-if="
            computedAuthProfile === 'admin' ||
              computedAuthProfile === 'maintenance'
          "
          icon
          flat
          color="primary"
          @click="methodDownloadCSV"
        >
          <v-icon>get_app</v-icon>
        </v-btn>
        <v-btn icon flat color="primary" @click="addSign = true"
          ><v-icon>add</v-icon></v-btn
        >
        <v-btn
          icon
          flat
          color="primary"
          @click="methodGetSignshopSignageGeoJson"
        >
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :headers="headers"
          :items="computedSignshopSignageGeoJsonFeatures"
          :rows-per-page-items="rows_per_page"
          :rows-per-page-text="rows_per_page_text"
          :search="search"
          class="elevation-1"
          :loading="computedSignshopSignageLoading"
        >
          <template slot="items" slot-scope="props">
            <tr
              @click="
                methodToggleSingleLayer(
                  'signshop',
                  'signage',
                  true,
                  props.item.properties.id
                )
              "
            >
              <td>{{ props.item.properties.struct_num }}</td>
              <td>{{ props.item.properties.zone }}</td>
              <td>{{ props.item.properties.run }}</td>
              <td>{{ props.item.properties.condition }}</td>
              <td>{{ getNormalDate(props.item.properties.modified) }}</td>
            </tr>
          </template>

          <!-- Alert when no results found -->
          <v-alert slot="no-results" :value="true" color="error" icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert
          >
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>

    <v-dialog
      v-model="addSign"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card>
          <v-btn
            icon
            @click="
              addSign = false;
              clearWatchLocation();
              lat = null;
              lng = null;
              accuracy = null;
              altitude = null;
              data_comments = null;
              data_trail_name = null;
              data_sign_loc = nul;
            "
          >
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title class="hidden-sm-and-down">Add Sign</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!tracking"
            :disabled="tracking"
            color="success"
            @click="geoWatchPosition()"
            >Start GPS</v-btn
          >
          <v-btn
            v-if="tracking"
            :disabled="!tracking"
            color="error"
            @click="clearWatchLocation()"
            >Stop GPS</v-btn
          >
          <v-spacer></v-spacer>
        </v-toolbar>
        <div
          style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
        >
          <v-data-table
            v-if="addSign"
            :items="addItemBlank"
            :hide-headers="addItemHideHeaders"
            :hide-actions="addItemHideActions"
          >
            <template slot="items">
              <tr>
                <td>Image</td>
                <td>
                  <image-uploader
                    @input="setOutput"
                    :quality="0.7"
                    :autoRotate="attemptAutoRotate"
                    outputFormat="base64"
                    class="fileinput2"
                    :preview="true"
                    accept=".jpg, .jpeg"
                    :key="attemptAutoRotate"
                  ></image-uploader>
                </td>
              </tr>
              <tr>
                <td>EXIF rotate?</td>
                <td><v-checkbox v-model="attemptAutoRotate" class="mt-2" /></td>
              </tr>
              <tr>
                <td>Latitude</td>
                <td>
                  <span v-if="!lat && tracking">Getting latitude...</span>
                  {{ lat }}
                </td>
              </tr>
              <tr>
                <td>Longitude</td>
                <td>
                  <span v-if="!lng && tracking">Getting longitude...</span>
                  {{ lng }}
                </td>
              </tr>
              <tr>
                <td>Accuracy</td>
                <td>
                  <span v-if="!accuracy && tracking">Getting accuracy...</span>
                  {{ accuracy }}
                  <span v-if="accuracy">m</span>
                </td>
              </tr>
              <tr>
                <td>Altitude</td>
                <td>
                  <span v-if="!altitude && tracking">Getting altitude...</span>
                  {{ altitude }}
                  <span v-if="altitude">m</span>
                </td>
              </tr>
              <tr>
                <td>Structure Number</td>
                <td>
                  <v-text-field
                    v-model="form.struct_num"
                    ref="signage_struct_num"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td>Mountain</td>
                <td>
                  <v-select
                    v-model="form.mountain"
                    :items="opt_mountain"
                    ref="signage_mountain"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Zone</td>
                <td>
                  <v-text-field
                    v-model="form.zone"
                    ref="signage_zone"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td>Run</td>
                <td>
                  <v-text-field
                    v-model="form.run"
                    ref="signage_run"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td>Condition</td>
                <td>
                  <v-select
                    v-model="form.condition"
                    :items="opt_condition"
                    ref="signage_condition"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Purpose</td>
                <td>
                  <v-select
                    v-model="form.st_purpose"
                    :items="opt_st_purpose"
                    ref="signage_st_purpose"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Sign Types</td>
                <td>
                  <v-select
                    v-model="form.sign_type1"
                    :items="opt_sign_type"
                    ref="signage_sign_type1"
                  ></v-select>
                  <v-select
                    v-model="form.sign_type2"
                    :items="opt_sign_type"
                    ref="signage_sign_type2"
                  ></v-select>
                  <v-select
                    v-model="form.sign_type3"
                    :items="opt_sign_type"
                    ref="signage_sign_type3"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Information</td>
                <td>
                  <v-checkbox
                    v-model="form.blue"
                    ref="signage_blue"
                    label="Blue"
                  ></v-checkbox>

                  <v-checkbox
                    v-model="form.green"
                    ref="signage_green"
                    label="Green"
                  ></v-checkbox>

                  <v-checkbox
                    v-model="form.black"
                    ref="signage_black"
                    label="Black"
                  ></v-checkbox>

                  <v-checkbox
                    v-model="form.t_park"
                    ref="signage_t_park"
                    label="Terrain Park"
                  ></v-checkbox>

                  <v-checkbox
                    v-model="form.low_light"
                    ref="signage_low_light"
                    label="Low Light"
                  ></v-checkbox>

                  <v-checkbox
                    v-model="form.lift"
                    ref="signage_lift"
                    label="Lift"
                  ></v-checkbox>

                  <v-checkbox
                    v-model="form.restaurant"
                    ref="signage_restaurant"
                    label="Restaraunt"
                  ></v-checkbox>

                  <v-checkbox
                    v-model="form.racecentre"
                    ref="signage_racecentre"
                    label="Race Centre"
                  ></v-checkbox>

                  <v-checkbox
                    v-model="form.strat_alli"
                    ref="signage_strat_alli"
                    label="Strategic Alliance"
                  ></v-checkbox>

                  <!-- <v-checkbox
                    v-model="form.telus"
                    ref="signage_telus"
                    label="Telus"
                  ></v-checkbox> -->

                  <v-checkbox
                    v-model="form.parking"
                    ref="signage_parking"
                    label="Parking"
                  ></v-checkbox>
                </td>
              </tr>
              <tr>
                <td>Banner Size</td>
                <td>
                  <v-text-field
                    v-model="form.bannersize"
                    ref="signage_bannersize"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td>Structure Size</td>
                <td>
                  <v-text-field
                    v-model="form.structsize"
                    ref="signage_structsize"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td>Damage Type</td>
                <td>
                  <v-select
                    v-model="form.dmg_type"
                    :items="opt_dmg_type"
                    ref="signage_dmg_type"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Action</td>
                <td>
                  <v-checkbox
                    v-model="form.a_paint"
                    ref="signage_a_paint"
                    label="Paint"
                  ></v-checkbox>

                  <v-checkbox
                    v-model="form.a_repair"
                    ref="signage_a_repair"
                    label="Repair"
                  ></v-checkbox>

                  <v-checkbox
                    v-model="form.a_f_insum"
                    ref="signage_a_f_insum"
                    label="Fix in summer"
                  ></v-checkbox>

                  <v-checkbox
                    v-model="form.a_f_inwin"
                    ref="signage_a_f_inwin"
                    label="Fix in winter"
                  ></v-checkbox>

                  <v-checkbox
                    v-model="form.a_na"
                    ref="signage_a_na"
                    label="N/A"
                  ></v-checkbox>
                </td>
              </tr>
              <tr>
                <td>On a Building?</td>
                <td>
                  <v-select
                    v-model="form.building"
                    :items="opt_building"
                    ref="signage_building"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Building</td>
                <td>
                  <v-text-field
                    v-model="form.bldg_name"
                    ref="signage_bldg_name"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td>Season</td>
                <td>
                  <v-select
                    v-model="form.season"
                    :items="opt_season"
                    ref="signage_season"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Flip</td>
                <td>
                  <v-select
                    v-model="form.flip"
                    :items="opt_flip"
                    ref="signage_flip"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Install Date</td>
                <td>
                  <v-text-field
                    v-model="form.instal_dt"
                    ref="signage_instal_dt"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td>Notes</td>
                <td>
                  <v-textarea
                    v-model="form.notes"
                    ref="signage_notes"
                  ></v-textarea>
                </td>
              </tr>
            </template>
            <template slot="footer">
              <tr>
                <td colspan="100%">
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                  <v-btn
                    @click.stop="
                      methodAddSignshopSignageGeoJson({
                        struct_num: form.struct_num,
                        mountain: form.mountain,
                        zone: form.zone,
                        run: form.run,
                        condition: form.condition,
                        st_purpose: form.st_purpose,
                        sign_type1: form.sign_type1,
                        sign_type2: form.sign_type2,
                        sign_type3: form.sign_type3,
                        bannersize: form.bannersize,
                        structsize: form.structsize,
                        dmg_type: form.dmg_type,
                        building: form.building,
                        bldg_name: form.bldg_name,
                        season: form.season,
                        flip: form.flip,
                        instal_dt: form.instal_dt,
                        notes: form.notes,
                        edit_by: computedAuth.profile.email,
                        a_na: methodBoolToNum(form.a_na),
                        a_repair: methodBoolToNum(form.a_repair),
                        a_paint: methodBoolToNum(form.a_paint),
                        a_f_insum: methodBoolToNum(form.a_f_insum),
                        a_f_inwin: methodBoolToNum(form.a_f_inwin),
                        blue: methodBoolToNum(form.blue),
                        green: methodBoolToNum(form.green),
                        black: methodBoolToNum(form.black),
                        t_park: methodBoolToNum(form.t_park),
                        low_light: methodBoolToNum(form.low_light),
                        lift: methodBoolToNum(form.lift),
                        restaurant: methodBoolToNum(form.restaurant),
                        racecentre: methodBoolToNum(form.racecentre),
                        strat_alli: methodBoolToNum(form.strat_alli),
                        // telus: methodBoolToNum(form.telus),
                        parking: methodBoolToNum(form.parking),
                        base64data: base64image
                      });
                      addSign = false;
                    "
                    color="success"
                    >Save</v-btn
                  >
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import { parse } from "json2csv";
export default {
  data() {
    return {
      form: {
        struct_num: null,
        mountain: null, //
        zone: null,
        run: null,
        condition: null, //
        st_purpose: null, //
        sign_type1: null, //
        sign_type2: null, //
        sign_type3: null, //
        bannersize: null,
        structsize: null,
        dmg_type: null, //
        building: null, //
        bldg_name: null,
        season: null, //
        flip: null, //
        instal_dt: null,
        notes: null,
        a_na: null,
        a_repair: null,
        a_f_insum: null,
        a_f_inwin: null,
        blue: null,
        green: null,
        black: null,
        t_park: null,
        low_light: null,
        lift: null,
        restaurant: null,
        racecentre: null,
        strat_alli: null,
        // telus: null,
        parking: null
      },
      attemptAutoRotate: true,
      addItemBlank: [""],
      addItemHideHeaders: true,
      addItemHideActions: true,
      addSign: false,
      base64image: null,
      lat: null,
      lng: null,
      accuracy: null,
      altitude: null,
      tracking: false,
      select_mountain_items: ["Both Mountains", "Whistler", "Blackcomb"],
      select_mountain_model: "Both Mountains",
      select_zone_model: "All Zones",
      loading: true,
      search: "",
      rows_per_page: [
        10,
        25,
        50,
        {
          text: "All",
          value: -1
        }
      ],
      rows_per_page_text: "Per page:",
      headers: [
        {
          text: "Structure #",
          value: "properties.struct_num"
        },
        {
          text: "Zone",
          value: "properties.zone"
        },
        {
          text: "Run",
          value: "properties.run"
        },
        {
          text: "Condition",
          value: "properties.condition"
        },
        {
          text: "Modified",
          value: "properties.modified"
        }
      ],
      disable_edit: false,
      opt_condition: [
        { text: "Good" },
        { text: "Poor" },
        { text: "Moderate" },
        { text: "Damaged" },
        { text: "Proposed" },
        { text: "Remove" },
        { text: "Look At" },
        { text: "Unknown" }
      ],
      opt_mountain: [{ text: "Whistler" }, { text: "Blackcomb" }],
      opt_st_purpose: [
        { text: "Information Board" },
        { text: "Directional - Information Board" },
        { text: "Directional - Banner" },
        { text: "Directional" },
        { text: "Banner - Information Board" },
        { text: "Banner" },
        { text: "Unknown" }
      ],
      opt_dmg_type: [
        { text: "Human" },
        { text: "Natural" },
        { text: "Unknown" }
      ],
      opt_sign_type: [
        { text: "Trail Sign" },
        { text: "Safety" },
        { text: "Map" },
        { text: "Light Map" },
        { text: "Light Board" },
        { text: "Grooming" },
        { text: "Digital" },
        { text: "Banner" },
        { text: "Unknown" }
      ],
      opt_building: [{ text: "Yes" }, { text: "No" }],
      opt_season: [
        { text: "Winter" },
        { text: "Summer" },
        { text: "Both" },
        { text: "Unknown" }
      ],
      opt_flip: [{ text: "Yes" }, { text: "No" }, { text: "Unknown" }]
    };
  },
  computed: {
    computedZones() {
      Array.prototype.unique = function() {
        return this.filter(function(value, index, self) {
          return self.indexOf(value) === index;
        });
      };
      if (
        this.$store.state.mapLayers.signshop.layers.signage.geojson.features
      ) {
        const zones = this.$store.state.mapLayers.signshop.layers.signage
          .geojson.features;
        let a = []; // blank array
        for (let i = 0; i < zones.length; i++) {
          a.push(zones[i].properties.zone); // push all sites into array a
        }

        let b = a.unique(); // 'filter' out duplicates

        return b; // returns only unique zones
      }
      return [];
    },
    computedSignshopSignageGeoJsonFeatures() {
      if (
        this.$store.state.mapLayers.signshop.layers.signage.geojson.features
      ) {
        const signage = this.$store.state.mapLayers.signshop.layers.signage
          .geojson.features;
        switch (this.select_mountain_model) {
          case "Whistler":
            return signage.filter(
              item => item.properties.mountain == "Whistler"
            );
          case "Blackcomb":
            return signage.filter(
              item => item.properties.mountain == "Blackcomb"
            );
          case "Both Mountains":
            return signage;
          default:
            return signage;
        }
      }
      return [];
    },
    computedSignshopSignageVisibility() {
      return this.$store.state.mapLayers.signshop.layers.signage.visibility
        .listView;
    },
    computedSignshopSignageLoading() {
      return this.$store.state.mapLayers.signshop.layers.signage.loading;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedAuth() {
      return this.$store.state.auth;
    }
  },
  methods: {
    methodDownloadCSV() {
      const fields = [
        {
          label: "Mountain",
          value: "properties.mountain"
        },
        {
          label: "Structure Number",
          value: "properties.struct_num"
        },
        {
          label: "Zone",
          value: "properties.zone"
        },
        {
          label: "Run",
          value: "properties.run"
        },
        {
          label: "Structure Purpose",
          value: "properties.st_purpose"
        },
        {
          label: "Sign Type 1",
          value: "properties.sign_type1"
        },
        {
          label: "Sign Type 2",
          value: "properties.sign_type2"
        },
        {
          label: "Sign Type 3",
          value: "properties.sign_type3"
        },
        {
          label: "Blue",
          value: "properties.blue"
        },
        {
          label: "Green",
          value: "properties.green"
        },
        {
          label: "Black",
          value: "properties.black"
        },
        {
          label: "Terrain Park",
          value: "properties.t_park"
        },
        {
          label: "Low Light",
          value: "properties.low_light"
        },
        {
          label: "Lift",
          value: "properties.lift"
        },
        {
          label: "Restaurant",
          value: "properties.restaurant"
        },
        {
          label: "Race Centre",
          value: "properties.racecentre"
        },
        {
          label: "Strategic Alliance",
          value: "properties.strat_alli"
        },
        // {
        //   label: "Telus",
        //   value: "properties.telus"
        // },
        {
          label: "Parking",
          value: "properties.parking"
        },
        {
          label: "On Building?",
          value: "properties.building"
        },
        {
          label: "Building Name",
          value: "properties.bldg_name"
        },
        {
          label: "Banner Size",
          value: "properties.bannersize"
        },
        {
          label: "Structure Size",
          value: "properties.structsize"
        },
        {
          label: "Condition",
          value: "properties.condition"
        },
        {
          label: "Damage Type",
          value: "properties.dmg_type"
        },
        {
          label: "Action Paint",
          value: "properties.a_paint"
        },
        {
          label: "Action Not Applicable",
          value: "properties.a_na"
        },
        {
          label: "Action Repair",
          value: "properties.a_repair"
        },
        {
          label: "Fix in Summer",
          value: "properties.a_f_insum"
        },
        {
          label: "Fix in Winter",
          value: "properties.a_f_inwin"
        },
        {
          label: "Flip?",
          value: "properties.flip"
        },
        {
          label: "Install Date",
          value: "properties.instal_dt"
        },
        {
          label: "Season",
          value: "properties.season"
        },
        {
          label: "Notes",
          value: "properties.notes"
        },
        {
          label: "Modified Date",
          value: "properties.modified"
        },
        {
          label: "Edit by",
          value: "properties.edit_by"
        }
      ];
      const opts = { fields };

      try {
        const csv = parse(
          this.$store.state.mapLayers.signshop.layers.signage.geojson.features.sort(
            (a, b) => {
              if (a.properties.struct_num < b.properties.struct_num) return -1;
              if (a.properties.struct_num > b.properties.struct_num) return 1;
              return 0;
            }
          ),
          opts
        );
        const blob = new Blob([csv], { type: "octet/stream" });
        const a = document.createElement("a");
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = "signshop_mountain_signage.csv";
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }, 0);
      } catch (err) {
        console.error(err);
      }
    },
    methodBoolToNum(bool) {
      if (bool == true) {
        return 1;
      } else {
        return 0;
      }
    },
    setOutput(file) {
      this.base64image = file;
    },
    geoSuccess(position) {
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
      this.accuracy = position.coords.accuracy;
      this.altitude = position.coords.altitude;
    },
    geoError() {
      console.log("geo error");
    },
    geoWatchPosition() {
      let geoOptions = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      };
      this.tracking = true;
      this.watchId = navigator.geolocation.watchPosition(
        this.geoSuccess,
        this.geoError,
        geoOptions
      );
    },
    clearWatchLocation() {
      navigator.geolocation.clearWatch(this.watchId);
      this.tracking = false;
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      return y + "-" + m + "-" + d;
    },
    // method to get geojson
    methodGetSignshopSignageGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/signshop/signage",
        dept: "signshop",
        layer: "signage",
        token: this.computedAuthToken
      });
    },
    methodAddSignshopSignageGeoJson(data) {
      let constFeature = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [this.lng, this.lat]
            },
            properties: {
              name: data.name,
              struct_num: data.struct_num,
              mountain: data.mountain,
              zone: data.zone,
              run: data.run,
              st_purpose: data.st_purpose,
              sign_type1: data.sign_type1,
              sign_type2: data.sign_type2,
              sign_type3: data.sign_type3,
              blue: data.blue,
              green: data.green,
              black: data.black,
              t_park: data.t_park,
              low_light: data.low_light,
              lift: data.lift,
              restaurant: data.restaurant,
              racecentre: data.racecentre,
              strat_alli: data.strat_alli,
              //  telus: data.telus,
              parking: data.parking,
              building: data.building,
              bldg_name: data.bldg_name,
              bannersize: data.bannersize,
              structsize: data.structsize,
              condition: data.condition,
              dmg_type: data.dmg_type,
              a_paint: data.a_paint,
              a_na: data.a_na,
              a_repair: data.a_repair,
              a_f_insum: data.a_f_insum,
              a_f_inwin: data.a_f_inwin,
              flip: data.flip,
              instal_dt: data.instal_dt,
              season: data.season,
              notes: data.notes,
              edit_by: data.edit_by,
              accuracy: this.accuracy,
              modified: this.pgDateFunc(Date.now())
            }
          }
        ]
      };
      this.$store
        .dispatch("actionAddJsonImage", {
          url: "https://api2.alchemymapping.com/vail/whistler/signshop/signage",
          imageUrl:
            "https://api2.alchemymapping.com/vail/whistler/signshop/signage/image",
          base64data: this.base64image,
          dept: "signshop",
          layer: "signage",
          token: this.computedAuthToken,
          payload: constFeature
        })
        .then(() => {
          setTimeout(() => {
            this.methodGetSignshopSignageGeoJson();
          }, 250);
        });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.signshop.layers.signage.visibility.listView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetSignshopSignageGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.signshop.layers.signage.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
